<script setup lang="ts">
  import type { DownloadableFile } from '@/types/File'
  import { useFileDownload } from '@/composables/useFileDownload'
  import { useI18n } from 'vue-i18n'
  import VgsButton from '@/components/common/VgsButton.vue'

  const { t } = useI18n()
  const { downloadFile, isLoading } = useFileDownload()

  const props = withDefaults(defineProps<DownloadableFile>(), {
    bytes: 0,
    intro: '',
    fieldIdentifier: 'file',
  })
</script>

<template>
  <VgsButton
    type="label"
    variant="quaternary"
    shape="rounded"
    icon-left="download"
    data-track="filnedlasting-knapp"
    :aria-label="t('download.urge', { file: props.name})"
    data-testid="file-download-button"
    @click="!isLoading && downloadFile(props)"
  >
    {{ props.name }}
  </VgsButton>
</template>

